import { registerFunctionalComponent } from 'js/lib/components/component'

registerFunctionalComponent('.js-c-pages-team-card', 'TeamCardComponent', initTeamCard)

function initTeamCard(component) {
  const trigger = component.element.querySelector('.js-card-bio-trigger')
  const bio = component.element.querySelector('.js-card-bio')

  if (!trigger || !bio) return

  component.useHandler(() => {
    const handleClick = () => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true'
      
      if (isExpanded) {
        bio.style.maxHeight = '0px'
        trigger.setAttribute('aria-expanded', 'false')
      } else {
        bio.style.maxHeight = bio.scrollHeight + 'px'
        trigger.setAttribute('aria-expanded', 'true')
      }
    }

    trigger.addEventListener('click', handleClick)

    // Return cleanup function
    return () => trigger.removeEventListener('click', handleClick)
  })
}
